module.exports = __webpack_public_path__ + "img/instagram.8252696.svg";